export default {
    account: {icon: 'fa-users'},
    activity: {icon: 'fa-genderless'},
    add: {icon: 'fa-plus'},
    add_square: {icon: 'fa-plus-square'},
    archived: {icon: 'fa-archive'},
    avatar: {icon: 'fa-user-circle', type: 'fas', transform: 'grow-8'},
    banned: {icon: 'fa-ban'},
    bars: {icon: 'fa-bars'},
    book: {icon: 'fa-book'},
    blocked: {icon: 'fa-circle', secondary: {icon: 'fa-slash', transform: 'shrink-6', type: 'fas'}},
    certificate: {icon: 'fa-certificate', type: 'fas'},
    ch_profile: {icon: 'fa-address-card'},
    ch_engagement: {icon: 'fa-bullseye'},
    ch_integration: {icon: 'fa-exchange'},
    ch_api: {icon: 'fa-cloud'},
    check: {icon: 'fa-check'},
    circle: {icon: 'fa-circle'},
    client: {icon: 'fa-user-alt'},
    clone: {icon: 'fa-file-plus'},
    close: {icon: 'fa-times'},
    undo: {icon: 'fa-undo'},
    coclient: {icon: 'fa-user-friends', type: 'far'},
    coladd: {icon: 'fa-arrow-alt-to-right'},
    collapse: {icon: 'fa-chevron-double-right'},
    columns: {icon: 'fa-columns'},
    convert: {icon: 'fa-exchange-alt'},
    comment: {icon: 'fa-comment'},
    completed: {icon: 'fa-check-circle'},
    connection_both: {
        icon: 'fa-link',
        type: 'far',
        transform: 'flip-h down-2 left-3 shrink-2',
        secondary: {icon: 'fa-arrows-h', transform: 'shrink-3 up-3 right-7'}
    },
    connection_in: {
        icon: 'fa-link',
        type: 'far',
        transform: 'flip-h down-2 left-3 shrink-2',
        secondary: {icon: 'fa-long-arrow-right', transform: 'shrink-3 up-3 right-7'}
    },
    connection_out: {
        icon: 'fa-link',
        type: 'far',
        transform: 'flip-h down-2 left-3 shrink-2',
        secondary: {icon: 'fa-long-arrow-left', transform: 'shrink-3 up-3 right-7'}
    },
    connection_error: {
        icon: 'fa-link',
        type: 'far',
        transform: 'flip-h down-2 left-3 shrink-2',
        secondary: {icon: 'fa-times', transform: 'shrink-3 up-3 right-7'}
    },
    copy: {icon: 'fa-copy'},
    csv: {icon: 'fa-file'},
    custodial: {icon: 'fa-wallet'},
    database: {icon: 'fa-database'},
    details: {icon: 'fa-pen'},
    disabled: {icon: 'fa-exclamation-square'},
    warning: {icon: 'fa-exclamation-triangle'},
    down: {icon: 'fa-chevron-down'},
    download: {icon: 'fa-download'},
    draft: {icon: 'fa-file-edit'},
    drop: {icon: 'fa-arrow-alt-down'},
    edit: {icon: 'fa-edit'},
    reference: { icon: 'fa-retweet' },
    search: { icon: 'fa-search' },
    el_text: {icon: 'fa-font'},
    el_numeric: {icon: 'fa-hashtag'},
    el_currency: {icon: 'fa-dollar-sign'},
    el_dropdown: {icon: 'fa-list'},
    el_phone: {icon: 'fa-phone'},
    el_email: {icon: 'fa-envelope'},
    el_address: {icon: 'fa-map-signs'},
    el_option: {icon: 'fa-check-square'},
    el_date: {icon: 'fa-calendar-alt'},
    el_year: {icon: 'fa-calendar-minus'},
    el_percentage: {icon: 'fa-percent'},
    el_textarea: {icon: 'fa-text-height'},
    el_calculated: {icon: 'fa-code-merge'},
    el_calculated_off: {
        icon: 'fa-code-merge',
        transform: 'left-5 down-2',
        secondary: {icon: 'fa-eye-slash', transform: 'shrink-4 up-4 right-3'}
    },
    el_encrypted: {icon: 'fa-shield'},
    el_document: {icon: 'fa-file-alt'},
    el_pdf: {icon: 'fa-file-pdf'},
    el_image: {icon: 'fa-file-image'},
    el_logo: {icon: 'fa-user-circle'},
    el_video: {icon: 'fa-video'},
    el_button: {icon: 'fa-rectangle-wide'},
    el_calendly: {icon: 'fa-calendar-alt'},
    el_badge: {icon: 'fa-badge'},
    el_signature: {icon: 'fa-pen-alt'},
    el_usersig: {icon: 'fa-pen-alt', type: 'fas'},
    el_initials: {icon: 'fa-signature'},
    el_boolean: {icon: 'fa-toggle-on'},
    email: {icon: 'fa-envelope'},
    empty: {icon: 'fa-empty-set'},
    enabled: {icon: 'fa-check-square'},
    engagement: {icon: 'fa-bullseye'},
    engagement_send: {
        icon: 'fa-bullseye',
        type: 'far light',
        secondary: {icon: 'fa-paper-plane', type: 'far dark', transform: 'shrink-7 down-4 right-5'}
    },
    engagement_edit: {
        icon: 'fa-bullseye',
        type: 'far light',
        secondary: {icon: 'fa-edit', type: 'far dark', transform: 'shrink-7 down-3 right-5'}
    },
    engagement_list: {
        icon: 'fa-bullseye',
        type: 'far light',
        secondary: {icon: 'fa-list-alt', type: 'far dark', transform: 'shrink-7 down-4 right-5'}
    },
    error: {icon: 'fa-exclamation-circle'},
    expand: {icon: 'fa-chevron-double-left'},
    pending: {icon: 'fa-hourglass-end'},
    premium_template: { icon: 'fa-file-invoice' },
    expired: {icon: 'fa-hourglass-end'},
    export: {icon: 'fa-upload'},
    external: {icon: 'fa-external-link'},
    favorite: {icon: 'fa-star'},
    file_upload: {icon: 'fa-file-upload'},
    flag_start: {icon: 'fa-flag'},
    flag_finish: {icon: 'fa-flag-checkered'},
    filter: {icon: 'fa-filter'},
    folders: {icon: 'fa-folders'},
    form: {icon: 'fa-file-alt'},
    forms: {
        icon: 'fa-bullseye',
        type: 'far',
        transform: 'left-3',
        secondary: {icon: 'fa-file-alt', type: 'far', transform: 'shrink-4 down-3 right-4', background: 'fa-file'}
    },
    forms_progress: {
        icon: 'fa-adjust',
        type: 'far',
        transform: 'left-3',
        secondary: {icon: 'fa-file-alt', type: 'far', transform: 'shrink-4 down-3 right-4', background: 'fa-file'}
    },
    forms_new: {
        icon: 'fa-dot-circle',
        type: 'far',
        transform: 'left-3',
        secondary: {icon: 'fa-file-alt', type: 'far', transform: 'shrink-4 down-3 right-4', background: 'fa-file'}
    },
    forms_completed: {
        icon: 'fa-check-circle',
        type: 'far',
        transform: 'left-3',
        secondary: {icon: 'fa-file-alt', type: 'far', transform: 'shrink-4 down-3 right-4', background: 'fa-file'}
    },
    hash: {icon: 'fa-hashtag'},
    help: {icon: 'fa-question-circle'},
    home: {icon: 'fa-home'},
    person: { icon: 'fa-id-card' },
    i_link: {icon: 'fa-link'},
    i_unlink: {icon: 'fa-unlink'},
    i_users: {icon: 'fa-users'},
    i_users_cog: {icon: 'fa-users-cog'},
    i_user_friends: {icon: 'fa-user-friends'},
    i_user: {icon: 'fa-user'},
    i_user_edit: {icon: 'fa-user-edit'},
    i_user_cog: {icon: 'fa-user-cog'},
    i_user_times: {icon: 'fa-user-times'},
    i_user_plus: {icon: 'fa-user-plus'},
    i_user_minus: {icon: 'fa-user-minus'},
    i_user_tie: {icon: 'fa-user-tie'},
    i_user_graduate: {icon: 'fa-user-graduate'},
    i_user_tag: {icon: 'fa-user-tag'},
    i_user_slash: {icon: 'fa-user-slash'},
    i_user_shield: {icon: 'fa-user-shield'},
    i_user_lock: {icon: 'fa-user-lock'},
    i_user_clock: {icon: 'fa-user-clock'},
    i_user_check: {icon: 'fa-user-check'},
    i_archive: {icon: 'fa-archive'},
    i_award: {icon: 'fa-award'},
    i_badge: {icon: 'fa-badge'},
    i_building: {icon: 'fa-building'},
    i_bullseye: {icon: 'fa-bullseye'},
    i_child: {icon: 'fa-child'},
    i_female: {icon: 'fa-female'},
    i_male: {icon: 'fa-male'},
    i_coins: {icon: 'fa-coins'},
    i_comments: {icon: 'fa-comments'},
    i_crown: {icon: 'fa-crown'},
    i_diamond: {icon: 'fa-gem'},
    i_dollar: {icon: 'fa-dollar-sign'},
    i_envelope: {icon: 'fa-envelope'},
    i_globe: {icon: 'fa-globe-americas'},
    i_heart: {icon: 'fa-heart'},
    i_lightbulb: {icon: 'fa-lightbulb'},
    i_medal: {icon: 'fa-medal'},
    i_money: {icon: 'fa-money-bill'},
    i_search: {icon: 'fa-search'},
    i_spade: {icon: 'fa-spade'},
    i_star: {icon: 'fa-star'},
    i_umbrella: {icon: 'fa-umbrella'},
    import: {icon: 'fa-download'},
    info: {icon: 'fa-info-circle'},
    information: {icon: 'fa-info'},
    install: {icon: 'fa-cube'},
    key: {icon: 'fa-key'},
    language: {icon: 'fa-language'},
    layout: {icon: 'fa-th-large'},
    left: {icon: 'fa-chevron-left'},
    library: {icon: 'fa-book'},
    library_form: {
        icon: 'fa-file-alt',
        transform: 'left-1 up-1',
        secondary: {icon: 'fa-plus-square', type: 'far', transform: 'shrink-4 right-6 down-5', background: 'fa-square'}
    },
    library_pdf: {
        icon: 'fa-file-pdf',
        transform: 'left-1 up-1',
        secondary: {icon: 'fa-plus-square', type: 'far', transform: 'shrink-4 right-6 down-5', background: 'fa-square'}
    },
    library_report: {
        icon: 'fa-file-spreadsheet',
        transform: 'left-1 up-1',
        secondary: {icon: 'fa-plus-square', type: 'far', transform: 'shrink-4 right-6 down-5', background: 'fa-square'}
    },
    link: {icon: 'fa-link'},
    lock: {icon: 'fa-lock'},
    mobile: {icon: 'fa-mobile'},
    move: {icon: 'fa-long-arrow-alt-right'},
    multiple: {icon: 'fa-window-restore', type: 'far'},
    multiple_error: {
        icon: 'fa-clone',
        type: 'far',
        transform: 'flip-v flip-h',
        secondary: {icon: 'fa-times', transform: 'shrink-5 left-2 down-2'}
    },
    not_started: {icon: 'fa-dot-circle'},
    notch: {icon: 'fa-circle-notch'},
    office: {icon: 'fa-user-friends'},
    op_addition: {icon: 'fa-plus'},
    op_subtraction: {icon: 'fa-minus'},
    op_multiplication: {icon: 'fa-times'},
    op_division: {icon: 'fa-divide'},
    op_concatenation: {icon: 'fa-i-cursor'},
    op_age: {icon: 'fa-clock'},
    op_get: {icon: 'fa-search'},
    op_value: {icon: 'fa-terminal'},
    op_equal: {icon: 'fa-equals'},
    op_notequal: {icon: 'fa-not-equal'},
    op_larger: {icon: 'fa-greater-than-equal'},
    op_smaller: {icon: 'fa-less-than-equal'},
    pen: {icon: 'fa-pen-alt'},
    pdf: {icon: 'fa-file-pdf'},
    pdfs: {
        icon: 'fa-bullseye',
        type: 'far',
        transform: 'left-3',
        secondary: {icon: 'fa-file-pdf', type: 'far', transform: 'shrink-4 down-3 right-4', background: 'fa-file'}
    },
    pdfs_progress: {
        icon: 'fa-adjust',
        type: 'far',
        transform: 'left-3',
        secondary: {icon: 'fa-file-pdf', type: 'far', transform: 'shrink-4 down-3 right-4', background: 'fa-file'}
    },
    pdfs_new: {
        icon: 'fa-dot-circle',
        type: 'far',
        transform: 'left-3',
        secondary: {icon: 'fa-file-pdf', type: 'far', transform: 'shrink-4 down-3 right-4', background: 'fa-file'}
    },
    pdfs_completed: {
        icon: 'fa-check-circle',
        type: 'far',
        transform: 'left-3',
        secondary: {icon: 'fa-file-pdf', type: 'far', transform: 'shrink-4 down-3 right-4', background: 'fa-file'}
    },
    phone: {icon: 'fa-phone'},
    play: {icon: 'fa-play'},
    pipeline: {icon: 'fa-code-commit'},
    pipeline_stage: {icon: 'fa-code-branch'},
    preview: {icon: 'fa-desktop'},
    print: {icon: 'fa-print'},
    profile: {icon: 'fa-address-card'},
    progress: {icon: 'fa-bullseye', secondary: {icon: 'fa-adjust', type: 'fas', transform: 'grow-4'}},
    prospect: {icon: 'fa-user-alt', secondary: {icon: 'fa-question', type: 'fas', transform: 'shrink-8 up-5 right-10'}},
    published: {icon: 'fa-file-check'},
    review: {icon: 'fa-file-code'},
    quality: {icon: 'fa-award', type: 'far'},
    reminder: {icon: 'fa-alarm-clock'},
    reminder_off: {icon: 'fa-alarm-clock', secondary: {icon: 'fa-ban', transform: 'grow-4'}},
    remove: {icon: 'fa-trash-alt'},
    report: {icon: 'fa-list-alt'},
    report_my: {icon: 'fa-list-alt', transform: 'shrink-3 left-2', secondary: {icon: 'fa-user-alt', type: 'fas', transform: 'shrink-6 down-4 right-8'}},
    report_template: {icon: 'fa-file-spreadsheet'},
    report_activity: {icon: 'fa-stream', type:'fal', transform:'left-2', secondary: {icon: 'fa-file-spreadsheet', type: 'far', transform: 'shrink-6 down-3 right-5', background:'fa-file'} },
    report_accounts: {icon: 'fa-users', type:'fal', transform:'left-2', secondary: {icon: 'fa-file-spreadsheet', type: 'far', transform: 'shrink-6 down-3 right-5', background:'fa-file'} },
    report_account_profiles: {icon: 'fa-address-card', type:'fal', transform:'left-2', secondary: {icon: 'fa-file-spreadsheet', type: 'far', transform: 'shrink-6 down-3 right-5', background:'fa-file'} },
    report_users: {icon: 'fa-user', type:'fal', transform:'left-2', secondary: {icon: 'fa-file-spreadsheet', type: 'far', transform: 'shrink-6 down-3 right-5', background:'fa-file'} },
    report_teams: {icon: 'fa-user-friends', type:'fal', transform:'left-2', secondary: {icon: 'fa-file-spreadsheet', type: 'far', transform: 'shrink-6 down-3 right-5', background:'fa-file'} },
    report_form_templates: {icon: 'fa-file-alt', type:'fal', transform:'left-2', secondary: {icon: 'fa-file-spreadsheet', type: 'far', transform: 'shrink-6 down-3 right-5', background:'fa-file'} },
    report_pdf_templates: {icon: 'fa-file-pdf', type:'fal', transform:'left-2', secondary: {icon: 'fa-file-spreadsheet', type: 'far', transform: 'shrink-6 down-3 right-5', background:'fa-file'} },
    report_engagements: {icon: 'fa-bullseye', type:'fal', transform:'left-2', secondary: {icon: 'fa-file-spreadsheet', type: 'far', transform: 'shrink-6 down-3 right-5', background:'fa-file'} },
    report_form_engagement_data: {icon: 'fa-database', type:'fal', transform:'left-2', secondary: {icon: 'fa-file-spreadsheet', type: 'far', transform: 'shrink-6 down-3 right-5', background:'fa-file'} },
    revision_prev: {
        icon: 'fa-undo-alt',
        type: 'far',
        transform: 'grow-2',
        secondary: {icon: 'fa-pen', type: 'fas', transform: 'shrink-8'}
    },
    revision_next: {
        icon: 'fa-redo-alt',
        type: 'far',
        transform: 'grow-2',
        secondary: {icon: 'fa-pen', type: 'fas', transform: 'shrink-8'}
    },
    revisions: {
        icon: 'fa-undo-alt',
        type: 'far',
        transform: 'grow-2',
        secondary: {icon: 'fa-pen', type: 'fas', transform: 'shrink-8'}
    },
    right: {icon: 'fa-chevron-right'},
    rollback: {icon: 'fa-undo-alt', type: 'far', transform: 'grow-2'},
    rowadd: {icon: 'fa-arrow-alt-to-bottom'},
    sad: {icon: 'fa-frown'},
    search: {icon: 'fa-search'},
    security: {icon: 'fa-shield-check'},
    send: {icon: 'fa-paper-plane'},
    settings: {icon: 'fa-cog'},
    shared: {icon: 'fa-share-alt'},
    shield: {icon: 'fa-shield'},
    signin: {icon: 'fa-sign-in-alt'},
    signout: {icon: 'fa-sign-out-alt'},
    single: {icon: 'fa-window-maximize'},
    square: {icon: 'fa-square'},
    structure: {icon: 'fa-line-columns'},
    success: {icon: 'fa-check-circle'},
    sync: {icon: 'fa-sync-alt'},
    tag: {icon: 'fa-tag'},
    tags: {icon: 'fa-tags'},
    tablet: {icon: 'fa-tablet'},
    tasks: {icon: 'fa-tasks'},
    template: {icon: 'fa-file-alt'},
    theme: {icon: 'fa-tint'},
    type_link: {icon: 'fa-code'},
    type_iframe: {icon: 'fa-browser'},
    type_button: {icon: 'fa-rectangle-wide'},
    type_bar: {icon: 'fa-window-maximize'},
    type_banner: {icon: 'fa-image'},
    type_url: {icon: 'fa-link'},
    unlock: {icon: 'fa-unlock'},
    up: {icon: 'fa-chevron-up'},
    upload: {icon: 'fa-upload'},
    user: {icon: 'fa-user'},
    visibility_print: {
        icon: 'fa-eye',
        type: 'far',
        transform: 'rotate-30 down-3 left-4 shrink-1',
        secondary: {icon: 'fa-print', transform: 'shrink-5 up-3 right-8'}
    },
    visibility_screen: {
        icon: 'fa-eye',
        type: 'far',
        transform: 'rotate-30 down-3 left-4 shrink-1',
        secondary: {icon: 'fa-desktop', transform: 'shrink-5 up-3 right-8'}
    },
    visibility_preview: {
        icon: 'fa-eye',
        type: 'far',
        transform: 'rotate-30 down-3 left-4 shrink-1',
        secondary: {icon: 'fa-user', transform: 'shrink-5 up-3 right-8'}
    },
    visibility_expr: {
        icon: 'fa-eye',
        type: 'far',
        transform: 'rotate-30 down-3 left-4 shrink-1',
        secondary: {icon: 'fa-sigma', transform: 'shrink-4 up-3 right-7'}
    },
    visibility_error: {
        icon: 'fa-eye',
        type: 'far',
        transform: 'rotate-30 down-3 left-4 shrink-1',
        secondary: {icon: 'fa-times', transform: 'shrink-3 up-3 right-7'}
    },
    web: {icon: 'fa-globe'},
    xls: {icon: 'fa-file-excel'},
    eye: {icon: 'fa-eye'},
    eye_off: {icon: 'fa-eye-slash'},
    file_export: {icon: 'fa-file-export', type: 'fal', first: 'fa-light'},
    file_import: {icon: 'fa-file-import', type: 'fal', first: 'fa-light'},
    stop: {icon: 'fa-stop-circle'},
}
